export const routeProps = {
  path: '/find_account',
  exact: true,
};

export default () => routeProps;
